import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

const useSearchFlowValveId = (interfaceId: number, id: number) => {
  return useQuery({
    queryKey: [queryKeys.flowValveDetail, id],
    queryFn: async () => {
      const { data } = await flowValveApi.getById(interfaceId, id)
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useSearchFlowValveId
